"use strict";

var LoggerInstance = require("js-logger").get("AbstractApi");

var ApiHelper = require("../shared/ApiHelper");
var QueryStringHelper = require("../shared/QueryStringHelper");

var AbstractApi = class {
	constructor() {
		if (this.constructor === AbstractApi) {
			throw new TypeError("Cannot construct AbstractApi instances directly!");
		}
	}

	get(ajaxSettings) {
		ajaxSettings.type = "GET";

		this._processQueryString(ajaxSettings);

		return $.ajax(ajaxSettings).fail((jqXHR, textStatus, errorThrown) => {
			if (textStatus !== "abort") {
				this._logError(ajaxSettings, jqXHR, textStatus, errorThrown);
			}
		});
	}

	post(ajaxSettings) {
		this._processQueryString(ajaxSettings);

		return this._requestWithBody(ajaxSettings, "POST");
	}

	put(ajaxSettings) {
		this._processQueryString(ajaxSettings);

		return this._requestWithBody(ajaxSettings, "PUT");
	}

	delete(ajaxSettings) {
		this._processQueryString(ajaxSettings);

		return this._requestWithBody(ajaxSettings, "DELETE");
	}

	_removeCaptchaSpinner(e) {
		var challenge = $("iframe[title*='recaptcha'][title*='challenge']");
		// This boolean is based on how Google is currently showing/hiding their reCaptcha challenge
		// If things start breaking, it might be because they have changed how they do this
		var isChallengeVisible = !(challenge.css("visibility") == "hidden");

		if (challenge.length > 0 && isChallengeVisible && !challenge.is(e.target) && challenge.has(e.target).length === 0) {
			$("#overlayWithSpinner").remove();
		}
	}

	_processQueryString(ajaxSettings) {
		var queryString;
		if (ajaxSettings.queryString) {
			if (typeof ajaxSettings.queryString === "string") {
				queryString = ajaxSettings.queryString;
			} else {
				queryString = QueryStringHelper.createQueryString(ajaxSettings.queryString);
			}

			if (queryString) {
				ajaxSettings.url = `${ajaxSettings.url}?${queryString}`;
			}

			delete ajaxSettings.queryString;
		}
	}

	_requestWithBody(ajaxSettings, type) {
		if (ajaxSettings.reCAPTCHA && window.reCAPTCHA) {
			ajaxSettings.headers = ajaxSettings.headers || {};

			// Do not challenge again if reCAPTCHA has already validated (this is the case with Apple and Google Pay).
			if (ajaxSettings.data && ajaxSettings.data.reCAPTCHAResponseToken) {
				ajaxSettings.headers.reCAPTCHAResponseToken = ajaxSettings.data.reCAPTCHAResponseToken;
				delete ajaxSettings.data.reCAPTCHAResponseToken;
				return this._performRequestWithBody(ajaxSettings, type);
			}

			var deferred = new $.Deferred();
			var that = this;
			document.addEventListener("mouseup", that._removeCaptchaSpinner);

			$("#recaptcha").one("Success", (event, token) => {
				ajaxSettings.headers.reCAPTCHAResponseToken = token;
				this._performRequestWithBody(ajaxSettings, type)
					.done(deferred.resolve)
					.fail(deferred.reject);
			});
			if (!window.callingReCAPTCHA) {
				grecaptcha.execute();
			}
			return deferred;

		}
		return this._performRequestWithBody(ajaxSettings, type);
	}

	_performRequestWithBody(ajaxSettings, type) {
		ajaxSettings.type = type;
		ajaxSettings.contentType = ajaxSettings.contentType || "application/json";
		if (ajaxSettings.contentType === "application/json" && typeof ajaxSettings.data !== "string") {
			ApiHelper.convertEmptyValuesToNull(ajaxSettings.data);
			ajaxSettings.data = JSON.stringify(ajaxSettings.data);
		}

		return $.ajax(ajaxSettings).fail((jqXHR, textStatus, errorThrown) => this._logError(ajaxSettings, jqXHR, textStatus, errorThrown));
	}

	_logError(settings, jqXHR, textStatus, errorThrown) {
		LoggerInstance.error(`Failed to ${settings.type} ${settings.url}.`, jqXHR, textStatus, errorThrown);
	}
};

module.exports = AbstractApi;


// WEBPACK FOOTER //
// ./Javascript/api/AbstractApi.jsx